import { render, staticRenderFns } from "./add-shelves.vue?vue&type=template&id=33866182&"
import script from "./add-shelves.vue?vue&type=script&lang=ts&"
export * from "./add-shelves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports